import { FC } from 'react';
import { Box, BoxProps, Divider } from '@chakra-ui/react';
import { formatAnniversary } from '../../helpers/dates';
import { RecognitionStar } from '../../types/RecognitionStar';
import { CbStarEntity, CbStarEntitySkeleton } from '../CbStarEntity';
import { CbEmptyCard } from '../CbEmptyCard/CbEmptyCard';
export interface CbRecognitionStarListProps extends BoxProps {
  recognitionStars: RecognitionStar[];
  activeFilter?: string;
  isLoading?: boolean;
  isTruncated?: boolean;
}
export const CbRecognitionStarList: FC<CbRecognitionStarListProps> = ({
  recognitionStars,
  activeFilter = 'Stars Received',
  isLoading,
  isTruncated,
  ...props
}) => {
  const actionText = activeFilter === 'Stars Received' ? 'awarded by' : 'awarded to';
  if (isLoading) {
    return <>
        <CbStarEntitySkeleton minHeight={{
        md: '70px'
      }} />
        <Divider marginY={5} />
        <CbStarEntitySkeleton minHeight={{
        md: '70px'
      }} />
      </>;
  }
  if (!recognitionStars.length) {
    return <CbEmptyCard msg={'No Recognition Stars... Yet.'} />;
  }
  return <Box {...props} data-sentry-element="Box" data-sentry-component="CbRecognitionStarList" data-sentry-source-file="CbRecognitionStarList.tsx">
      {recognitionStars.map((star, i) => {
      const userType = activeFilter === 'Stars Received' ? star?.awardingUser : star?.awardedUser;
      return <>
            <CbStarEntity reason={star?.reason} name={userType?.fullName} starColor={star?.color} starId={star?.id} starImage={star?.image} starIcon={star?.icon} starName={star?.category} action={actionText} date={formatAnniversary(star?.createdAt)} profileId={userType?.id} minHeight={{
          md: '70px'
        }} isTruncated={isTruncated} />
            {i !== recognitionStars.length - 1 && <Divider marginY={3} />}
          </>;
    })}
    </Box>;
};